import { useForm } from 'react-hook-form';
import Toaster from '../../../Components/Toaster/Toaster';
import CommonImageUpload from '../../../Components/Common/CommonImageUpload';
import InputField from '../../../Components/Common/InputField';
import CommonTouchFieldForEdit from '../../../Components/Common/CommonTouchFieldForEdit';
import SelectTextArea from '../../../Components/Common/SelectTextArea';
import {
  useB2BProfileUpdate,
  useGetB2BProfile,
} from '../apiEndpoints/b2bBuyerSellerEndpoint';
import CommonFormBtn from '../../../Components/Common/CommonFormBtn';
import { useEffect } from 'react';

const B2BEditProfile = ({ handleClose }: { handleClose?: () => void }) => {
  const Toast = Toaster();
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    setValue,
    resetField,
    formState: { errors, dirtyFields },
    getValues,
  } = useForm<any>();

  const { data } = useGetB2BProfile();
  const { mutate, isPending, isSuccess } = useB2BProfileUpdate();

  const onSubmit = async () => {
    const formData = new FormData();
    const currentValues = getValues();

    const editFields = CommonTouchFieldForEdit({
      dirtyFields,
      currentValues,
      existingValues: data?.data,
    });
    if (editFields && !Object?.keys(editFields)?.length) {
      return Toast.fire({
        icon: 'error',
        title: 'Change field first',
      });
    } else {
      Object.keys(editFields).forEach((item) => {
        if (item === 'b2b_photo') {
          formData.append(item, currentValues[item][0]);
        } else {
          formData.append(item, currentValues[item]);
        }
      });

      mutate(formData);
    }
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose?.();
    }
  }, [isSuccess]);
  return (
    <>
      <div className='login-wrapper'>
        <div className='login-div'>
          <div className='visitor-registration-page'>
            <div className='login-form'>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className='text-start'>
                  <p className='fw-bold fs-5 text-center text-decoration-underline'>
                    Edit your Information
                  </p>
                </div>

                <div className='row g-3 mx'>
                  {/* First Name */}
                  <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <InputField
                      type='text'
                      defaultValue={data?.data?.b2b_first_name}
                      register={register('b2b_first_name')}
                      label='First Name'
                      placeholder='Enter first name'
                    />
                  </div>

                  {/* Last Name */}
                  <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <InputField
                      type='text'
                      defaultValue={data?.data?.b2b_last_name}
                      register={register('b2b_last_name')}
                      label='Last Name'
                      placeholder='Enter last name'
                    />
                  </div>

                  {/* Designation */}
                  <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <InputField
                      type='text'
                      defaultValue={data?.data?.b2b_designation}
                      register={register('b2b_designation')}
                      label='Designation'
                      placeholder='Designation'
                    />
                  </div>

                  {/* Mobile No */}
                  <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <InputField
                      type='number'
                      defaultValue={data?.data?.b2b_phone}
                      register={register('b2b_phone')}
                      label='Mobile No'
                      placeholder='Mobile No'
                    />
                  </div>

                  {/* Email */}

                  {/* Company Name */}
                  <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <InputField
                      type='text'
                      defaultValue={data?.data?.b2b_organization}
                      register={register('b2b_organization')}
                      label='Company Name'
                      placeholder='Company Name'
                    />
                  </div>
                  <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <InputField
                      type='email'
                      defaultValue={data?.data?.b2b_email}
                      register={register('b2b_email')}
                      label='Email'
                      placeholder='Enter official email'
                    />
                  </div>
                  {/* Website */}
                  <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <InputField
                      type='text'
                      defaultValue={data?.data?.b2b_website}
                      register={register('b2b_website')}
                      label='Website'
                      placeholder='Website'
                    />
                  </div>

                  {/* Address */}
                  <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <InputField
                      type='text'
                      defaultValue={data?.data?.b2b_address}
                      register={register('b2b_address')}
                      label='Address'
                      placeholder='Address'
                    />
                  </div>

                  {/* About Company */}

                  {/* Telephone */}
                  <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <InputField
                      type='number'
                      defaultValue={data?.data?.b2b_telephone_number}
                      register={register('b2b_telephone_number')}
                      label='Telephone'
                      placeholder='Telephone No'
                    />
                  </div>

                  <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <SelectTextArea
                      defaultValue={data?.data?.b2b_intention}
                      register={register('b2b_intention')}
                      label='Write your Intension'
                    />
                  </div>
                  <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
                    <SelectTextArea
                      defaultValue={data?.data?.b2b_company_brief}
                      register={register('b2b_company_brief')}
                      label='About Company'
                    />
                  </div>
                  <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2'>
                    <div className='row'>
                      <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 mt-2'>
                        <CommonImageUpload
                          register={register}
                          label='Passport Size Photo'
                          setError={setError}
                          clearErrors={clearErrors}
                          setValue={setValue}
                          resetField={resetField}
                          errors={errors}
                          fileName='b2b_photo'
                          defaultValue={data?.data?.b2b_photo}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <CommonFormBtn loading={isPending} btnText='Update' />
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default B2BEditProfile;
